import { Badge, Box, ButtonGroup, Grid, IconButton, Tab, Tabs, Tooltip, Zoom } from "@material-ui/core";
import {
  Backup,
  CloudDownload,
  CloudUpload,
  DoneAll,
  ErrorOutline,
  Pageview,
  SendTwoTone,
  ThumbDown,
  ThumbUp,
} from "@material-ui/icons";
import * as React from "react";
import { FC, Fragment, useState } from "react";
import {
  Button,
  CreateButton,
  Datagrid,
  ExportButton,
  Filter,
  FilterProps,
  FunctionField,
  ListProps,
  SelectInput,
  TextField,
  TopToolbar,
  useNotify,
  useRefresh,
} from "react-admin";
import { useHistory } from "react-router-dom";
import { formatDecimalTr } from "../../Helper/FormatDecimalTr";
import UpdatedByField from "../../../src/Components/ReferenceFields/UpdatedBy/UpdatedByField";
import { UploadFile } from "../../../src/Components/UploadFile";
import { AircraftUtilizationStatus } from "../../../src/Enums/AircraftUtilizationStatus";
import { useAppDataProvider } from "../../../src/dataprovider";
import { CustomDateField } from "../../Components/CustomDateField";
import { CustomDatetime } from "../../Components/CustomDatetime";
import { DetailButton } from "../../Components/DetailButton";
import CreatedByField from "../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { DefaultCreatedDateSort, DefaultPerPageSize, PeriodMonths } from "../../Constants/Constant";
import * as YearList from "../../Constants/YearList";
import { ExcelExport } from "../../Helper/ExportExcel";
import AircraftUtilizationApproveBulk from "./AircraftUtilizationApproveBulk";
import AircraftUtilizationFilePopup from "./AircraftUtilizationFilePopup";
import AircraftUtilizationUploadFile from "./AircraftUtilizationUploadFile";
import { AircraftUtilizationExcelName } from "./Constant/Excel";
import { SourceAircraftUtilization, TitleAircraftUtilization } from "./Constant/Source";
import { useAuth } from "@airborne/react-admin";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import LoadingPopup from "../AircraftUnderMaintenance/List/Loading";
import { ImportExcelInformationDialog } from "./AircraftUtilizationBulkReview";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";
import CopyableTableWrapper from "../../../src/Components/CopyableTableWrapper";
import AiReliabilitySection from "./AiReliability/AiReliabilitySection";
import AircraftUtilizationNullFlightsPopup from "./AircraftUtilizationNullFlightsPopup";

const AircraftUtilizationFilter: FC<Omit<FilterProps, "children">> = props => {
  const [customerList, setCustomerList] = useState([] as any);
  const [selectedCustomer, setselectedCustomer] = useState("" as any);
  const dataProvider = useAppDataProvider();
  const [acRegList, setAcRegList] = useState([] as any);
  const { user } = useAuth();
  const _zeroValue: number = 0;

  React.useEffect(() => {
    GetCustomerList();
  }, []);

  const GetCustomerList = async () => {
    dataProvider
      .getList("customers/", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "customerName", order: "ASC" },
        filter: {},
      })
      .then(response => {
        let dataLength: number = response.data.length;
        setCustomerList([]);
        if (dataLength > 0) {
          let data = response.data;
          setCustomerList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    if (selectedCustomer) {
      dataProvider
        .getList("cdmaircraft/" + selectedCustomer, {
          pagination: { page: 1, perPage: 9999 },
          sort: { field: "acReg", order: "ASC" },
          filter: {},
        })
        .then(response => {
          let dataLength: number = response.data.length;
          if (dataLength > _zeroValue) {
            setAcRegList(response.data);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }, [selectedCustomer]);

  const customerChangeEvent = e => {
    setselectedCustomer(e.target.value);
  };

  return (
    <Filter {...props}>
      <SelectInput
        source="periodYear__eq"
        label="Period Year"
        choices={YearList.default}
        optionText="key"
        optionValue="key"
        alwaysOn
        fullWidth
      ></SelectInput>
      <SelectInput
        source="periodMonth__eq"
        choices={PeriodMonths}
        label="Period Month"
        optionText="month"
        optionValue="value"
        alwaysOn
        fullWidth
      ></SelectInput>
      {user?.isCustomer === false && (
        <SelectInput
          source="ownerCode__eq"
          choices={customerList}
          optionText="customerName"
          optionValue="ownerCode"
          label="CUSTOMER"
          onChange={customerChangeEvent}
          fullWidth
          alwaysOn
        ></SelectInput>
      )}
      {selectedCustomer ? (
        <SelectInput
          source="acRegId__eq"
          choices={acRegList}
          optionText="acReg"
          optionValue="id"
          label="AC-REG"
          fullWidth
          alwaysOn
        />
      ) : null}
      <CustomDatetime source="createdDate__gte" label="Tarih(>=)" alwaysOn />
      <CustomDatetime source="createdDate__lte" label="Tarih (<=)" alwaysOn />
    </Filter>
  );
};

const UploadFileAction = props => {
  return (
    <UploadFile
      label=""
      multiple={false}
      placeholder={"Upload"}
      // onHandleFileExecute={() => history.go(0)}
      source="aircraftutilizationfilerelations"
      object={{
        aircraftUtilizationId: props?.record?.id,
      }}
    />
  );
};

const TabbedDatagrid: FC<any> = props => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [isFileGrid, setIsFileGrid] = React.useState(false);
  const [request, setRequest] = React.useState<any>({});
  const [isNullFlightsOpen, setIsNullFlightsOpen] = React.useState(false);
  const [nullFlightsRecord, setNullFlightsRecord] = React.useState<any>({});
  const refresh = useRefresh();

  const SendUpdate = final_data => {
    dataProvider
      .putAircraftUtilization(final_data)
      .then(result => {
        notify(`Record Updated`, "success", false, true);
        refresh();
      })
      .catch(error => notify(`${error}`, "error", false, true));
  };

  const AcceptButton = props => {
    const onClick = e => {
      var final_data = { ...props.record };
      final_data.status = AircraftUtilizationStatus.Accepted;
      SendUpdate(final_data);
    };
    if (props.record.status === AircraftUtilizationStatus.Offered) {
      return (
        <IconButton {...props} style={{ width: 40, color: "#008000" }} onClick={onClick}>
          <Tooltip title="Accept">
            <ThumbUp />
          </Tooltip>
        </IconButton>
      );
    } else {
      return <></>;
    }
  };
  const RejectButton = props => {
    const onClick = e => {
      var final_data = { ...props.record };
      final_data.status = AircraftUtilizationStatus.Rejected;
      SendUpdate(final_data);
    };

    if (props.record.status === AircraftUtilizationStatus.Offered) {
      return (
        <IconButton {...props} style={{ width: 40, color: "#FF0000" }} onClick={onClick}>
          <Tooltip title="Reject">
            <ThumbDown />
          </Tooltip>
        </IconButton>
      );
    } else {
      return <></>;
    }
  };
  const SendToApproveButton = props => {
    const onClick = e => {
      var final_data = { ...props.record };
      final_data.status = AircraftUtilizationStatus.Offered;
      SendUpdate(final_data);
    };

    if (props.record.status === AircraftUtilizationStatus.Rejected) {
      return (
        <IconButton {...props} style={{ width: 40, color: "#FFFF00" }} onClick={onClick}>
          <Tooltip title="Reject">
            <SendTwoTone />
          </Tooltip>
        </IconButton>
      );
    } else {
      return <></>;
    }
  };
  const FileUploadDialogButton = props => {
    return (
      <IconButton {...props} onClick={handleFileDialogOpen(props.record)}>
        <Tooltip title="Upload File">
          <Backup />
        </Tooltip>
      </IconButton>
    );
  };
  const FileGridPopup = props => {
    return (
      <IconButton
        style={{ width: 40 }}
        onClick={() => {
          fieldsInClick(props.record);
        }}
      >
        <Tooltip TransitionComponent={Zoom} title="Details">
          <Pageview />
        </Tooltip>
      </IconButton>
    );
  };

  const fieldsInClick = props => {
    setRequest(props);
    setIsFileGrid(true);
  };
  const handleFileDialogOpen = record => () => {
    props.handleFileDialogOpen?.(record);
  };
  const handleAircraftUtilizationFilePopupClose = () => {
    setIsFileGrid(false);
  };

  const WarningButton = (props: any) => {
    const record = props?.record;
    const nullFlightCount = record?.nullFlights?.length ?? 0;
    const hasWarning =
      nullFlightCount > 0 || record?.frCycle == null || record?.frHour == null || record?.frMinute == null;
    if (!hasWarning) return null;
    const tooltipTitle = nullFlightCount > 0 ? `${nullFlightCount} tahmini uçuş` : "Data Warning";
    return (
      <IconButton
        style={{ width: 40, color: "#FF0000" }}
        onClick={() => {
          setNullFlightsRecord(record);
          setIsNullFlightsOpen(true);
        }}
      >
        <Tooltip title={tooltipTitle}>
          {nullFlightCount > 0 ? (
            <Badge badgeContent={nullFlightCount} color="error">
              <ErrorOutline />
            </Badge>
          ) : (
            <ErrorOutline />
          )}
        </Tooltip>
      </IconButton>
    );
  };

  const Actions = props => {
    let record = props?.record;
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <FileGridPopup {...props} />
          <FileUploadDialogButton {...props} />
          <DetailButton label="Actions" resource={SourceAircraftUtilization} {...props} />
          {user?.isCustomer === false && <AcceptButton {...props} />}
          {user?.isCustomer === false && <RejectButton {...props} />}
          {user?.isCustomer === true && <SendToApproveButton {...props} />}
          {user?.isCustomer === false && <WarningButton {...props} />}
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <>
      <Fragment>
        <CopyableTableWrapper>
          <Datagrid {...props} optimized hasBulkActions={false}>
            <Actions label="Actions" />
            {user?.isCustomer === false && <TextField source="ownerCode" label={"Customer"} />}

            <TextField source="acRegistration" label="AC REG" />
            <TextField source="periodYear" label="PERIOD YEAR" />
            <TextField source="periodMonth" label="PERIOD MONTH" />
            <TextField source="flightCycle" label="FLIGHT CYCLE" />
            <TextField source="flightHour" label="FLIGHT HOUR" />
            <TextField source="flightMinute" label="FLIGHT MINUTE" />
            {user?.isCustomer === false && (
              <FunctionField
                label="FR CYCLE"
                render={(record: any) => (record?.frCycle != null ? record.frCycle : "—")}
              />
            )}
            {user?.isCustomer === false && (
              <FunctionField label="FR HOUR" render={(record: any) => (record?.frHour != null ? record.frHour : "—")} />
            )}
            {user?.isCustomer === false && (
              <FunctionField
                label="FR MINUTE"
                render={(record: any) => (record?.frMinute != null ? record.frMinute : "—")}
              />
            )}
            {user?.isCustomer === false && (
              <FunctionField
                label="AVG MISSING H"
                render={(record: any) => formatDecimalTr(record?.avgMissingHours)}
              />
            )}
            {user?.isCustomer === false && (
              <FunctionField label="EST ADD H" render={(record: any) => formatDecimalTr(record?.estAddHours)} />
            )}
            {user?.isCustomer === false && (
              <FunctionField
                label="ESTIMATED FLIGHT H"
                render={(record: any) => formatDecimalTr(record?.estimatedFlightHours)}
              />
            )}
            <CreatedByField label="CREATED BY" link={false} />
            <CustomDateField source="createdDate" label="CREATED DATE" showTime />
            <UpdatedByField label="MODIFIED BY" link={false} />
            <CustomDateField source="updatedDate" label="MODIFIED DATE" showTime />

            <FunctionField
              label="Status"
              render={record => {
                return record?.status === AircraftUtilizationStatus.Accepted
                  ? "TT Accepted"
                  : record?.status === AircraftUtilizationStatus.Rejected
                    ? "TT Rejected"
                    : "Waiting TT Approval";
              }}
            />
          </Datagrid>
        </CopyableTableWrapper>
      </Fragment>
      <Grid>
        {isFileGrid && (
          <AircraftUtilizationFilePopup
            open={isFileGrid}
            aircraftUtilizationDetail={request}
            handleClose={handleAircraftUtilizationFilePopupClose}
          />
        )}
      </Grid>
      <Grid>
        {isNullFlightsOpen && (
          <AircraftUtilizationNullFlightsPopup
            open={isNullFlightsOpen}
            record={nullFlightsRecord}
            handleClose={() => setIsNullFlightsOpen(false)}
          />
        )}
      </Grid>
    </>
  );
};

const AircraftUtilizationList: FC<ListProps> = props => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = React.useState(0);
  const [isShopReportFields, setIsShopReportFields] = React.useState(false);
  const [isUploadFileDialogOpen, setIsUploadFileDialogOpen] = React.useState(false);
  const [fileUploadRecord, setFileUploadRecord] = React.useState(false);
  const [tempData, setTempData] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const handleShopReportFieldsClose = () => setIsShopReportFields(false);
  const handleFileDialogClose = () => setIsUploadFileDialogOpen(false);
  const handleClick = () => setIsShopReportFields(true);

  const handleFileDialogOpen = model => {
    setIsUploadFileDialogOpen(true);
    setFileUploadRecord(model);
  };

  const exporter = records => {
    const data = records.map(record => {
      const row: Record<string, any> = {
        Customer: record.ownerCode,
        "Ac Reg": record.acRegistration,
        "Flight Cycle": record.flightCycle,
        "Flight Hour": record.flightHour,
        "Flight Minute": record.flightMinute,
      };
      if (user?.isCustomer === false) {
        row["FR Cycle"] = record.frCycle != null ? record.frCycle : "—";
        row["FR Hour"] = record.frHour != null ? record.frHour : "—";
        row["FR Minute"] = record.frMinute != null ? record.frMinute : "—";
        row["AVG MISSING H"] = formatDecimalTr(record.avgMissingHours);
        row["EST ADD H"] = formatDecimalTr(record.estAddHours);
        row["ESTIMATED FLIGHT H"] = formatDecimalTr(record.estimatedFlightHours);
      }
      row["Period Year"] = record.periodYear;
      row["Period Month"] = record.periodMonth;
      row["Created By"] = record.createdBy;
      row["Created Date"] = record.createdDate;
      return row;
    });
    const columns = Object.keys(data[0]).map(key => ({ header: key }));
    ExcelExport(columns, data, AircraftUtilizationExcelName);
  };

  const ListActions = () => (
    <TopToolbar>
      {user?.isCustomer === false && (
        <Button onClick={handleClick} label={"Approve All"}>
          <DoneAll />
        </Button>
      )}
      <CreateButton />
      <Button onClick={ExportTemplateClickButton} label="Export Template">
        {<CloudDownload />}
      </Button>
      <Button onClick={ImportClickButton} label="Import Excel">
        {<CloudUpload />}
      </Button>
      <ExportButton maxResults={10000} />
    </TopToolbar>
  );

  const ExportTemplateClickButton = () => {
    const newValues = [
      {
        OwnerCode: `Please Enter Owner Code (Required) - Ex: ${user?.isCustomer ? user?.ownerCode : "THY-O"}`,
        AcReg: "Please Enter Ac-Reg (Required) - Ex: TC-LYZ",
        PeriodYear: "Please Enter Period Year (Required) Ex: 2024",
        PeriodMonth: "Please Enter Period Month (Required) (Between 1-12) - Ex: 10",
        FlightHour: "Please Enter Flight Hour - Ex: 1",
        FlightMinute: "Please Enter Flight Minute (Between 0-59) - Ex: 1",
        FlightCycle: "Please Enter Flight Cycle - Ex: 1",
      },
    ];
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "Aircraft Utilization Import Template";

    const ws = XLSX.utils.json_to_sheet(newValues);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(excelData, fileName + fileExtension);
  };

  const ImportClickButton = () => {
    document.getElementById("fileInput")?.click();
  };

  const getExcelTempData = (data: any[]) => {
    setLoading(true);
    dataProvider
      .postAircraftUtilizationTempCreate(data)
      .then(response => {
        if (response?.data?.length !== 0) {
          setTempData(response?.data);
        }
        setOpenPopup(true);
        setLoading(false);
      })
      .catch(error => {
        notify(`Failed: ${error.message}`, "error");
        setLoading(false);
      });
  };

  const fileChange = e => {
    setLoading(true);
    try {
      let file: File = e.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = e => {
        let arrayBuffer: any = fileReader.result;
        var data = new Uint8Array(arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) {
          arr[i] = String.fromCharCode(data[i]);
        }
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var sheetName = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[sheetName];
        var dataList = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        dataList = dataList.map((x: any) => {
          return {
            ...x,
            ...{
              AcRegId: 0,
              Status: user?.isCustomer ? AircraftUtilizationStatus.Offered : AircraftUtilizationStatus.Accepted,
            },
          };
        });
        getExcelTempData(dataList);
      };
    } catch (error) {
      setLoading(false);
      notify(`Failed: ${error}`, "error");
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        {user?.isCustomer === false && (
          <Tabs
            value={activeTab}
            onChange={(_e, newValue) => setActiveTab(newValue)}
            indicatorColor="primary"
            textColor="primary"
            style={{ marginBottom: 8, borderBottom: "1px solid #e0e0e0" }}
          >
            <Tab label="Kullanım Listesi" />
            <Tab label="AI Güvenilirlik" />
          </Tabs>
        )}
        {activeTab === 0 && (
          <>
            <input
              hidden
              id="fileInput"
              accept=".csv,.xlsv,.xlsx,.msg,application/vnd.ms-outlook"
              type="file"
              onChange={e => fileChange(e)}
            ></input>
            <PoolList
              {...props}
              title={TitleAircraftUtilization.list}
              sort={DefaultCreatedDateSort}
              perPage={DefaultPerPageSize}
              exporter={exporter}
              filters={<AircraftUtilizationFilter />}
              filter={user?.isCustomer ? { ownerCode__eq: user?.ownerCode } : {}}
              actions={<ListActions />}
            >
              <TabbedDatagrid handleFileDialogOpen={handleFileDialogOpen} />
            </PoolList>
            <Grid>
              {isShopReportFields && (
                <AircraftUtilizationApproveBulk open={true} handleClose={handleShopReportFieldsClose} />
              )}
            </Grid>
            <Grid>
              <AircraftUtilizationUploadFile
                open={isUploadFileDialogOpen}
                handleClose={handleFileDialogClose}
                record={fileUploadRecord}
              />
            </Grid>
            {loading && <LoadingPopup loading={loading} />}
            <ImportExcelInformationDialog
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
              setLoading={setLoading}
              tempData={tempData}
              notify={notify}
              refresh={refresh}
              dataProvider={dataProvider}
            />
          </>
        )}
        {activeTab === 1 && user?.isCustomer === false && (
          <Box p={2}>
            <AiReliabilitySection />
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default AircraftUtilizationList;
